import { frontendURL } from '../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/rental-indices'),
      name: 'rental_indices_wrapper',
      meta: {
        permissions: ['administrator'],
      },
      component: () => import('./Wrapper.vue'),
      children: [
        {
          path: '',
          name: 'rental_indices_index',
          meta: {
            permissions: ['administrator'],
          },
          component: () => import('./Index.vue'),
        },
      ],
    },
  ],
};
